var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / maps / pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3516 23.7895L13.0093 23.2152C18.5403 18.3856 21.3516 14.1687 21.3516 10.4619C21.3516 5.21258 17.2545 1.46191 12.3516 1.46191C7.44862 1.46191 3.35156 5.21258 3.35156 10.4619C3.35156 14.1687 6.16287 18.3856 11.6938 23.2152L12.3516 23.7895ZM12.3516 21.1253C7.65817 16.8955 5.35156 13.3111 5.35156 10.4619C5.35156 6.35852 8.51568 3.46191 12.3516 3.46191C16.1874 3.46191 19.3516 6.35852 19.3516 10.4619C19.3516 13.3111 17.045 16.8955 12.3516 21.1253ZM12.3516 5.46191C15.113 5.46191 17.3516 7.70049 17.3516 10.4619C17.3516 13.2233 15.113 15.4619 12.3516 15.4619C9.59014 15.4619 7.35156 13.2233 7.35156 10.4619C7.35156 7.70049 9.59014 5.46191 12.3516 5.46191ZM9.35156 10.4619C9.35156 8.80506 10.6947 7.46191 12.3516 7.46191C14.0084 7.46191 15.3516 8.80506 15.3516 10.4619C15.3516 12.1188 14.0084 13.4619 12.3516 13.4619C10.6947 13.4619 9.35156 12.1188 9.35156 10.4619Z",
    fill: "#B3B2B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.fc5fb131511fe57285624480aeb2fe6b.svg";
export { ForwardRef as ReactComponent };